import store from "..";
import { onSignOutSuccess } from "./sessionSlice";
import { userLoggedOut } from "./userSlice";
import { resetCounts } from "../sideNavCountsSlice";
import { pusherService } from "services/pusher";
import { clearLoginPasswordVerification } from "utils/loginPasswordVerification";
import { clearDownloadOtpVerification } from "utils/downloadOtpVerification";

import { authStore } from "auth/authStore";

export const signOutGlobally = () => {
  try {
    pusherService.disconnect();

    authStore.clearAuth();
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("isPasswordExpiryIn2Days");
    // localStorage.removeItem("remainDays");
    localStorage.removeItem("isLogin");
    localStorage.removeItem("userEmail")
    localStorage.removeItem("widget_user_auth_token")
    localStorage.removeItem("dataLengthInPage")
    localStorage.removeItem("skipStripeReminder")
    localStorage.removeItem("domainReminderOpen")
    localStorage.removeItem("professionalDomainReminderOpen")
    localStorage.removeItem("skipProfessionalDomainReminder")
    localStorage.removeItem("skipPackageUpdatesReminder")
    clearLoginPasswordVerification();
    clearDownloadOtpVerification();
    store.dispatch(onSignOutSuccess());
    store.dispatch({ type: "reset" });

    return {
      status: "success",
      message: "Successfully logged out",
    };
  } catch (errors) {
    return {
      status: "failed",
      message: errors?.response?.data || errors.toString(),
    };
  }
};
